import { inject } from '@angular/core';
import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

export function requestHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): any {
  const document = inject(DOCUMENT);

  const domain = `${document.location.protocol}//${document.location.host}`;
  const headers: Record<string, string> = {
    'request-domain': domain,
    'x-frontend-request': `${window?.location}`
  };
  req = req.clone({ setHeaders: headers });

  return next(req);
}
